"use client";

import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const [isMobileOpen, setIsMobileOpen] = useState(false);

  useEffect(() => {
    // Console Easter Egg movido para cá (Client Component)
    console.log(`
      %c
      ██╗  ██╗ █████╗ ██╗   ██╗███████╗███████╗
      ██║ ██╔╝██╔══██╗╚██╗ ██╔╝╚══███╔╝╚══███╔╝
      █████╔╝ ███████║ ╚████╔╝   ███╔╝   ███╔╝ 
      ██╔═██╗ ██╔══██║  ╚██╔╝   ███╔╝   ███╔╝  
      ██║  ██╗██║  ██║   ██║   ███████╗███████╗
      ╚═╝  ╚═╝╚═╝  ╚═╝   ╚═╝   ╚══════╝╚══════╝
      
      %c👨‍💻 Developed by Kayzz
      %cNeed a premium website? Let's talk.
      `,
      'color: #0ea5e9; font-family: monospace; font-weight: bold;',
      'color: #fbbf24; font-size: 14px; font-weight: bold; margin-top: 10px;',
      'color: #e5e7eb; font-size: 12px;'
    );
  }, []);

  // Function to handle scroll to section
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileOpen(false);
    }
  };

  const navLinks = [
    { name: 'Home', id: 'home' },
    { name: 'Sobre', id: 'about' },
    { name: 'Skills', id: 'skills' },
    { name: 'Projetos', id: 'projects' },
    { name: 'Contato', id: 'contact' },
  ];

  return (
    <header className="fixed top-0 w-full z-50 mix-blend-difference text-white py-6">
      <div className="container mx-auto px-6 flex justify-between items-center">
        <button 
          onClick={() => scrollToSection('home')} 
          className="flex items-center gap-3 group hover:opacity-80 transition-opacity"
        >
          {/* Logo White - Mix Blend Difference inverterá para preto se o fundo for branco */}
          <img 
            src="https://res.cloudinary.com/ddxo3s8an/image/upload/v1769899937/LogoJkayzz_kkuoqa.png" 
            alt="Kayzz Logo" 
            width={40}
            height={40}
            className="w-10 h-10 object-contain"
          />
          <span className="text-2xl font-bold tracking-tighter">
            KAYZZ<span className="text-blue-primary">_</span>
          </span>
        </button>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <button
              key={link.id}
              onClick={() => scrollToSection(link.id)}
              className="text-sm font-medium uppercase tracking-widest hover:text-blue-primary transition-colors relative group"
            >
              {link.name}
              <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-primary transition-all group-hover:w-full"></span>
            </button>
          ))}
        </nav>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-white z-50"
          onClick={() => setIsMobileOpen(!isMobileOpen)}
          aria-label={isMobileOpen ? "Fechar Menu" : "Abrir Menu"}
        >
          {isMobileOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isMobileOpen && (
        <div className="md:hidden fixed inset-0 bg-black/95 backdrop-blur-xl z-40 flex items-center justify-center">
          <div className="flex flex-col gap-8 text-center">
            {navLinks.map((link) => (
              <button
                key={link.id}
                onClick={() => scrollToSection(link.id)}
                className="text-2xl font-light uppercase tracking-widest text-white hover:text-blue-primary"
              >
                {link.name}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;